import React from "react";
import { Container, Header, Segment, Image, Icon } from "semantic-ui-react";
import "../../node_modules/semantic-ui-css/semantic.min.css"; // Import Semantic UI CSS
import Typography from "@mui/material/Typography";

const ReleaseNotes = () => {
  const releaseNotes = [
    {
      date: "05/14/2021",
      title: "Mobile Enhancements (Experimental)",
      description:
        "Very basic (minimal) functionality like searching a symbol and viewing the Stock page can now be performed in mobile devices using a mobile browser. For best experience, access SimplyStock website in a desktop or laptop computer.",
      images: [
        `${process.env.PUBLIC_URL}/images/release/mobile1.jpg`,
        `${process.env.PUBLIC_URL}/images/release/mobile2.jpg`,
      ],
      subSections: [
        {
          title: "Redesigned Stock Page",
          content:
            "Company details main page is redesigned to include stock chart (credit: TradingView)",
          image: `${process.env.PUBLIC_URL}/images/release/new_stock_window.PNG`,
        },
        {
          title: "Deep Dive Reports in Stock Page",
          content:
            "- A new deep dive reports section is added to stock main page to show (free or paid) Deep Dive Analysts Reports for the underlying stock by various industry experts and Analysts",
          image: `${process.env.PUBLIC_URL}/images/release/deepdive1.PNG`,
        },
        {
          title: "Deep Dive Reports in Tools section",
          content:
            "- A new deep dive report is added under Tools -> Deep Dive Reports to show the (free or paid) Analysts Reports by various industry experts and Analysts",
          images: [
            `${process.env.PUBLIC_URL}/images/release/deepdive2.PNG`,
            `${process.env.PUBLIC_URL}/images/release/deepdive3.PNG`,
          ],
        },
        {
          title: "ETF Page Enhancements (Stock Holdings)",
          content:
            '-A new "Stock Holdings" tab is added to ETF Profile page to show the stock reports and snapshots for all the stocks in that ETF. This will greatly help to compare and analyze the ETF effectiveness.',
          image: `${process.env.PUBLIC_URL}/images/release/etf_stock_holdings.PNG`,
        },
      ],
    },
    {
      date: "03/30/2021",
      title: "Stock Window",
      description:
        "Company details pages are now conveniently shown in a new window without leaving underlying stocks page (screener, favorites, snapshots, index maps, earnings calendar etc) This new feature will allow you to continue to do the research in the current page without losing the context",
      image: `${process.env.PUBLIC_URL}/images/release/stock_window.PNG`,
      subSections: [
        {
          title: "Major Stock Holders",
          content:
            "- A new hyperlink (to external website) is provided to show the Institution ownership of the stock",
          image: `${process.env.PUBLIC_URL}/images/release/institution_ownership.PNG`,
        },
        {
          title: "Tooltips",
          content:
            "-Tool Tips are now shown on the Home Screen Index maps, sector gainers and loser screens with Current Price and today's price increase/decrease",
          image: `${process.env.PUBLIC_URL}/images/release/tooltip_gainers.PNG`,
        },
        {
          content:
            "-Tool Tips are now added on the Earnings Calendar to show estimated EPS value",
          image: `${process.env.PUBLIC_URL}/images/release/tooltip_earnings.PNG`,
        },
        {
          title: "Enhanced Screeners",
          content:
            "Screener/Investment Ideas are now enhanced with more information about the screener idea or the screener. Portfolios of Investment Gurus will now show the images of the Guru",
          image: `${process.env.PUBLIC_URL}/images/release/enhanced_screener.PNG`,
        },
        {
          title: "Special Country Screeners",
          content:
            'New handy country screeners are added under "Screeners" that navigates directly to specific country',
          images: [
            `${process.env.PUBLIC_URL}/images/release/country_screeners_menu.PNG`,
            `${process.env.PUBLIC_URL}/images/release/country_screener.PNG`,
          ],
        },
      ],
    },
    {
      date: "01/22/2021",
      title: "SnapShots for Screeners",
      description:
        "Now you can select any of your favorite screener and see stocks snapshots in the screener page (in Snapshots tab).",
      image: `${process.env.PUBLIC_URL}/images/release/screener-snapshots.PNG`,
      subSections: [
        {
          title: "Earnings Calendar",
          content: "Earnings Calendar is now available under 'Tools' Menu.",
          image: `${process.env.PUBLIC_URL}/images/release/earningscal1.PNG`,
        },
        {
          title: "New Watchlists for 2021",
          content:
            "3 New curated stock watchlists for 2021 are now available under the Investment Ideas menu.",
          image: `${process.env.PUBLIC_URL}/images/release/2021wl.PNG`,
        },
        {
          title: "Updates to Screeners",
          content:
            'Several handy stock screeners are added under "Screeners" that navigates directly to specific sectors, industries',
          image: `${process.env.PUBLIC_URL}/images/release/special_screeners.PNG`,
        },
        {
          title: "Screeners Performance Report",
          content:
            "A new performance report is added under Tools Menu that gives a performance of every available sector, investment idea including your favorites stocks list so you can compare and see which group of stocks or sectors and performing better",
          images: [
            `${process.env.PUBLIC_URL}/images/release/perf_report.PNG`,
            `${process.env.PUBLIC_URL}/images/release/perf_report1.PNG`,
          ],
        },
      ],
    },
    {
      date: "12/04/2020",
      title: "Favorites Enhancements",
      description: "Favorites Page is enhanced with the following tabs",
      images: [
        `${process.env.PUBLIC_URL}/images/release/fav_menu.PNG`,
        `${process.env.PUBLIC_URL}/images/release/fav_sector.PNG`,
        `${process.env.PUBLIC_URL}/images/release/fav_map.PNG`,
      ],
      subSections: [
        {
          title: "Home Page Enhancements",
          description: "Home Page now enhanced to show the following tabs",
          images: [
            `${process.env.PUBLIC_URL}/images/release/home_menu.PNG`,
            `${process.env.PUBLIC_URL}/images/release/top_gainers.PNG`,
            `${process.env.PUBLIC_URL}/images/release/sector_gainers.PNG`,
            `${process.env.PUBLIC_URL}/images/release/top10_sector.PNG`,
            `${process.env.PUBLIC_URL}/images/release/dow30_sector.PNG`,
            `${process.env.PUBLIC_URL}/images/release/nasdaq_sector.PNG`,
            `${process.env.PUBLIC_URL}/images/release/sp_sector.PNG`,
            `${process.env.PUBLIC_URL}/images/release/dow_map.PNG`,
            `${process.env.PUBLIC_URL}/images/release/nasdaq_map.PNG`,
            `${process.env.PUBLIC_URL}/images/release/sp_map.PNG`,
          ],
        },
        {
          title: "New Menu Item 'Special Sectors' added",
          content:
            "A new Menu Item 'Special Sectors' is now added to bring list of stocks on non traditional sectors",
          image: `${process.env.PUBLIC_URL}/images/release/special_sector.PNG`,
        },
        {
          title: "Sector Screeners added",
          content:
            "A new handy sector screener menu added under Specail Screeners to quickly accessing the stocks in each major sector",
          image: `${process.env.PUBLIC_URL}/images/release/sector_screener.PNG`,
        },
        {
          title: "Fund Gurus lists moved",
          content:
            "Fund Gurus Menu Item is now moved under Investment Ideas as sub group name 'Gurus'",
          image: `${process.env.PUBLIC_URL}/images/release/fund_gurus.PNG`,
        },
      ],
    },
    {
      date: "10/09/2020",
      title: "Gainers and Losers",
      description:
        "Home Page is now enhanced to show Gainers and Losers in the entire US Market, Dow Jones list, S&P list, NASDAQ list and Russell Small Cap list. (Note:The Price quotes are delayed by 15 minutes)",
      image: `${process.env.PUBLIC_URL}/images/release/homepage.PNG`,
      subSections: [
        {
          title: "Browse the Index Stocks",
          content:
            "You can now click on the Index in the home page and go to screener page directly. For example, clicking on Dow Jones Index will take you to the Dow Jones 30 Screener",
          image: `${process.env.PUBLIC_URL}/images/release/index.PNG`,
        },
        {
          title: "NASDAQ Composite Index Screener",
          content:
            "NASDAQ Composite Index 100 Stocks screener is now added to Screener Menu",
          image: `${process.env.PUBLIC_URL}/images/release/nasdaq.PNG`,
        },
        {
          title: "Stock Upgrades/Downgrades",
          content:
            "Major Analysts upgrades and downgrades are now available in the company profile page",
          image: `${process.env.PUBLIC_URL}/images/release/stockgrade.PNG`,
        },
      ],
    },
    {
      date: "09/25/2020",
      title: "Stock Performance",
      description:
        "Stock performance is added for several periods (1 day, 1 Week, 1 Month, 1 Year, YTD and from recent S&P Bottom) to Company and ETF Profile pages",
      images: [
        `${process.env.PUBLIC_URL}/images/release/stock_performance.PNG`,
        `${process.env.PUBLIC_URL}/images/release/etf_performance.PNG`,
      ],
      subSections: [
        {
          title: "ETF Holdings",
          content:
            "Company Profile page now shows the top 15 ETFs holding this stock and the weight percentage.",
          image: `${process.env.PUBLIC_URL}/images/release/etf_holdings.PNG`,
        },
        {
          title: "ETF Country Allocations",
          content: "Country Allocations for an ETF is now shown in ETF Profile",
          image: `${process.env.PUBLIC_URL}/images/release/etf_country.PNG`,
        },
        {
          title: "Stock & ETF Screener",
          content:
            "A new ETF Screener is now added to the Screener Menu. Full Scrrener is renamed to 'Stock Screener'",
          image: `${process.env.PUBLIC_URL}/images/release/etf_screener.PNG`,
        },
      ],
    },
    {
      date: "09/11/2020",
      title: "Search Box Improvements",
      description:
        "-Search Results are improved to show the selected symbol on the top\n-Search Results now has a scroll bar and fixed height for easier navigation",
      image: `${process.env.PUBLIC_URL}/images/release/search.PNG`,
      subSections: [
        {
          title: "New Screeners",
          content:
            "-New screeners are added for S & P, DowJones, Russell Index companies under Screener Menu",
          image: `${process.env.PUBLIC_URL}/images/release/sp.PNG`,
        },
        {
          title: "ETFs are now available",
          description:
            "-ETFs are now searchable in the website. ETF holdings breakdown by sector and top 50 holdings are showin in hte ETF profile\n-Note: Currently ETFs can not be added to favorites, and they wont be included in screener results",
          image: `${process.env.PUBLIC_URL}/images/release/etf.PNG`,
        },
      ],
    },
    {
      date: "08/28/2020",
      title: "New Menu to show your favorites",
      description:
        "-A New Menu Item is added to show favorites as a list. Very soon you will be able to add multiple favorite lists",
      image: `${process.env.PUBLIC_URL}/images/release/favorties_menu.PNG`,
      subSections: [
        {
          title: "Performance Metrics",
          content:
            "-Performance Metrics are added to Investment Ideas, Fund Gurus and Favorites",
          image: `${process.env.PUBLIC_URL}/images/release/performance.PNG`,
        },
        {
          title: "Point and Click Company name to load full details",
          content:
            '-Now you can click on the symbol from Screener results, "Investment Ideas", "Fund Gurus", "Compare to Peers", "Compare Stocks" and Favorites to directly load the company details. (you will see your mouse icon change to hand)',
        },
        {
          title: "Terms and Conditions",
          content:
            "- Website is updated with Terms and Conditions. Please read carefully",
        },
        {
          title: "Screener Results are now more readable",
          content:
            "- Screener results screen column name widths are adjusted to fully display its name",
        },
      ],
    },
    {
      date: "07/31/2020",
      title: "IPO Calendar:",
      description:
        "- Now you can access the recent and upcoming IPOs from Tools -> IPO Calendar. Please note that, these symbols information is not available in SimplyStock yet",
      images: [
        `${process.env.PUBLIC_URL}/images/release/ipo1.PNG`,
        `${process.env.PUBLIC_URL}/images/release/ipo2.PNG`,
      ],
      subSections: [
        {
          title: "Analysts Recommendations:",
          content:
            "-Now you can find Analysts recommendations in Company Profile page below the StockRadar chart",
          image: `${process.env.PUBLIC_URL}/images/release/analyst.PNG`,
        },
        {
          title: "Company News and News Sentiment",
          description:
            "-Latest company news can be found in the bottom section of the Company Profile page (scroll down to see)\n-Sentiment Analysis is now added to company news and Bullish and Bearish sentiment percentages are shown in company's news section",
          image: `${process.env.PUBLIC_URL}/images/release/news.PNG`,
        },
      ],
    },
    {
      date: "07/17/2020",
      title: "Compare Results now show Stock Radar Charts",
      description:
        "-A new 'Favorites' feature is added to website.\n-You can now add a stock to your favorites by simply clicking on 'Add to Favorites' button from Company Page\n-If the stock is no longer a favorite, you can click on 'Remove from Favorites' button to remove the stock from your favorites\n-You can access your favorites by clicking on your name -> 'Favorites' from the dropdown\n-You can now Signout by selecting 'Sign out' option from the dropdown menu under your name",
    },
    {
      date: "06/27/2020",
      title: "Website is now enabled with HTTPS and SSL",
      description:
        "-A radar chart is now shown in the main Company Profile page that gives a glimpse of the stock's strength from different fundamentals.\n-Stock Chart is now added to 'Chart' page of Company Profile",
    },
    {
      date: "06/20/2020",
      title: "",
      description:
        "-A color coded Slider is added to show the 52 Week Price Range. A red slider indicates that the current price is near towards its 52 week high price and green color indicates that it is near to the 52 weeks low.\n-Stock Compare Results are now shown with color coded values\n-Financial tab is now improved with Charts and color coded values\n-Company Profile page and Header page look and feel is enhanced\n-A new Tools menu is added to top navigation bar for more upcoming features. Compare Stocks feature is now moved under Tools menu.",
    },
    {
      date: "06/13/2020",
      title: "",
      description:
        "-Complete make over of the Fundamental Analysis screens\n-Color coding is added through out the application\n-Tiny charts are now shown with background horizontal and vertical gridlines, and in teal color now\n-Major Holders external link is added under 'Jump to Other Sites' section in Company Profile page\n-Price changes and % price change is now shown next to Current Price (Day Range)\n-Screener results now uses all the available height\n-Economic Moat screen is now showing YoY growth Values and charts\n-Fundamental Analysis screens are center aligned horizontally\n-Company name is limited to first 30 characters in Company Profile Page\n-Symbol name is now shown next to the company name in parenthesis\n-Top navigation bar position is fixed, so it is always stays on the top when scrolling vertically\n-'Hedge Fund Gurus' Menu Title is changed to 'Fund Gurus'\n-Footer top portion is now shown in all the pages.",
    },
    {
      date: "06/06/2020",
      title: "",
      description:
        "-A new 'Help' menu is added to show 'Site Help', 'What's New', 'Submit Feature' and 'Blog'\n-You can now search any company by typing it's Ticker name or Company name\n-Now you can see the Legendary portofoilios under 'Fund Gurus' menu\n-Handy links are proivded in the Company Profile page to jump to other financial websites\n-Company description is added on the Company Profile page\n-Now You can use 'Submit Feature' to request any new website feature (Help -> Submit Feature)\n-You can now click on SimplyStock Logo to go back to main page.\n-First few columns are fixed (like Excel column freeze) in Screener results\n-A friendly message is shown, if there is no data avaialble for a given ticker\n-Tickers database is refined to remove ETFs and Funds for now.",
    },
  ];

  const renderSubSections = (subSections) => {
    if (!subSections) return null;

    return subSections.map((section, index) => (
      <React.Fragment key={index}>
        <Header as="h4" color="teal" style={{ marginTop: "1em" }}>
          {section.title}
        </Header>
        {section.description && <p>{section.description}</p>}
        {section.content && <p>{section.content}</p>}
        {section.image && (
          <Image
            src={section.image}
            fluid
            style={{
              marginBottom: "1em",
              maxHeight: "500px",
              objectFit: "contain",
            }}
          />
        )}
        {section.images &&
          section.images.map((img, i) => (
            <Image
              key={i}
              src={img}
              fluid
              style={{
                marginBottom: "1em",
                maxHeight: "500px",
                objectFit: "contain",
              }}
            />
          ))}
      </React.Fragment>
    ));
  };

  const renderReleaseNotes = () => {
    return releaseNotes
      .filter((note) => note && note.date)
      .map((note, index) => (
        <Segment raised key={index} style={{ marginTop: "1.5em" }}>
          <Header as="h3" color="blue">
            <Icon name="calendar alternate outline" /> Release Notes: {note.date}
          </Header>
        {note.description && <p>{note.description}</p>}
        {note.image && (
          <Image
            src={note.image}
            fluid
            style={{
              marginBottom: "1em",
              maxHeight: "500px",
              objectFit: "contain",
            }}
          />
        )}
        {note.images &&
          note.images.map((img, i) => (
            <Image
              key={i}
              src={img}
              fluid
              style={{
                marginBottom: "1em",
                maxHeight: "500px",
                objectFit: "contain",
              }}
            />
          ))}
        {renderSubSections(note.subSections)}
      </Segment>
    ));
  };

  return (
    <Container style={{ padding: "1em" }}>
      <Typography
        variant="h5"
        gutterBottom
        align="center"
        sx={{
          color: "primary.dark",
          fontWeight: 600,
          mb: 2,
          mt: 0.5,
          fontSize: { xs: "1.5rem", md: "1.75rem" },
          letterSpacing: "-0.02em",
        }}
      >
        {" "}
        <Icon name="newspaper" size="large" />
        Whats New (Release Updates)
      </Typography>

      {renderReleaseNotes()}
    </Container>
  );
};

export default ReleaseNotes;
